import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  // state
  const cookieAcceptTime = ref<number|undefined>(undefined)
  const country = ref<string|undefined>(undefined)
  const language = ref<string>('en')

  // getters
  const getCookieAcceptTime = () => cookieAcceptTime.value ? new Date(cookieAcceptTime.value) : undefined

  // setters
  const setCookieAcceptTime = (time: Date|undefined) => {
    cookieAcceptTime.value = time?.getTime()
  }
  const setLanguage = (lang: string) => {
    language.value = lang
  }

  // actions

  return {
    cookieAcceptTime,
    country,
    language,

    getCookieAcceptTime,

    setCookieAcceptTime,
    setLanguage,
  }
}, { persist: !import.meta.env.SSR })
